import { combineReducers } from 'redux';

import { reducer as authReducer } from './auth';
import { reducer as crudReducer } from './crud';
import { reducer as erpReducer } from './erp';
import { reducer as adavancedCrudReducer } from './adavancedCrud';
import { reducer as settingsReducer } from './settings';
import { reducer as translateReducer } from './translate';
import { reducer as userReducer } from './user';
import roleReducer from './role/reducer';
import { reducer as notificationReducer } from './notification';

// Combine all reducers.

const rootReducer = combineReducers({
  auth: authReducer,
  crud: crudReducer,
  erp: erpReducer,
  adavancedCrud: adavancedCrudReducer,
  settings: settingsReducer,
  translate: translateReducer,
  user: userReducer,
  roles: roleReducer,
  notification: notificationReducer,
});

export default rootReducer;
